import { API_BASE_URL } from "@/config/serverApiConfig";

const resolveNotificationErrorMessage = (response = {}) =>
  response?.strMessage ||
  response?.message ||
  response?.error ||
  "Request failed";

const isNotificationResponseSuccessful = (response = {}) => {
  if (!response || typeof response !== "object") return false;
  if (response.success === false) return false;
  const statusCode = Number(response.statusCode || 200);
  if (Number.isFinite(statusCode) && statusCode >= 400) return false;
  if (`${response.message || ""}`.trim().toLowerCase() === "failed") return false;
  return true;
};

const buildNotificationApiUrl = (path = "") => {
  const normalizedPath = `${path || ""}`.trim();
  const slashPath = normalizedPath.startsWith("/")
    ? normalizedPath
    : `/${normalizedPath}`;
  return new URL(slashPath, API_BASE_URL).toString();
};

export {
  resolveNotificationErrorMessage,
  isNotificationResponseSuccessful,
  buildNotificationApiUrl,
};
